import { IComponentOptions } from 'angular';
import { WizardFilterActionsCtrl } from './wizard-filter-actions.controller';

export const WizardFilterActionsComponent: IComponentOptions = {
  bindings: {
    data: '<',
    options: '<',
    additionalActions: '<',
  },
  template: require('./wizard-filter-actions.html'),
  controller: WizardFilterActionsCtrl,
};
